// Import the local image
import popupPerformanceThumb from '../assets/images/TFNjekE4xm4-SD.jpg';
import testingThumb from '../assets/images/Y1N1TSTMiig-HD.jpg';
import customizingThumb from '../assets/images/EvXJ8nb97nQ-SD.jpg';
import installationThumb from '../assets/images/j6Bkh5Z5voQ-HD.jpg';
import livePreviewThumb from '../assets/images/GkpD8xwlxlQ-HD.jpg';
import emailThumb from '../assets/images/u_Rwkg7FE7s-HD.jpg';
import advancedThumb from '../assets/images/99vu2WvgDUc-HD.jpg';

const videoGuidesData = {
  // Categories for filtering
  categories: [
    { id: 'all', name: 'All Guides' },
    { id: 'basics', name: 'Getting Started' },
    { id: 'advanced', name: 'Advanced Features' },
    { id: 'conversion', name: 'Conversion Tips' },
    { id: 'design', name: 'Design' }
  ],
  
  // Video data
  videos: [
    {
      id: 1,
      title: 'Getting Started with HelloBar',
      description: 'Learn the basics of HelloBar and how to set up your first popup',
      category: 'basics',
      url: 'https://www.youtube.com/watch?v=8ZTxWGvRd_o',
      thumbnail: 'https://i.ytimg.com/vi/8ZTxWGvRd_o/maxresdefault.jpg'
    },
    {
      id: 2,
      title: 'Custom Targeting Feature',
      description: 'Learn how to targeting rules in Hello Bar',
      category: 'advanced',
      url: 'https://www.youtube.com/watch?v=99vu2WvgDUc',
      thumbnail: advancedThumb
    },
    {
      id: 3,
      title: 'Email Collection Strategies',
      description: 'Best practices for collecting emails with HelloBar',
      category: 'conversion',
      url: 'https://www.youtube.com/watch?v=u_Rwkg7FE7s',
      thumbnail: emailThumb
    },
    {
      id: 4,
      title: 'Customizing Your Popups',
      description: 'Learn how to create beautiful, branded popups that convert',
      category: 'design',
      url: 'https://www.youtube.com/watch?v=EvXJ8nb97nQ',
      thumbnail: customizingThumb
    },
    {
      id: 5,
      title: 'A/B Testing for Conversions',
      description: 'How to optimize your popups with A/B testing',
      category: 'conversion',
      url: 'https://www.youtube.com/watch?v=Y1N1TSTMiig',
      thumbnail: testingThumb
    },
    {
      id: 6,
      title: 'Tracking your Hello Bar Popup Performance',
      description: 'Monitor how your Hello Bar popup is performing and ensure that efforts are aligned with your overarching business goals and objectives!',
      category: 'design',
      url: 'https://www.youtube.com/watch?v=TFNjekE4xm4',
      thumbnail: popupPerformanceThumb
    },
    {
      id: 7,
      title: 'HelloBar Installation Guide',
      description: 'Step-by-step guide to installing HelloBar on your website',
      category: 'basics',
      url: 'https://www.youtube.com/watch?v=j6Bkh5Z5voQ',
      thumbnail: installationThumb
    },
    {
      id: 8,
      title: 'Live Preview Feature',
      description: 'It valuable opportunity to review and refine your content',
      category: 'advanced',
      url: 'https://www.youtube.com/watch?v=GkpD8xwlxlQ',
      thumbnail: livePreviewThumb
    }
  ],
  
  // Additional resources
  resources: [
    {
      id: 1,
      title: 'Knowledge Base',
      description: 'Browse our comprehensive documentation',
      icon: '📚',
      url: 'https://support.hellobar.com/support/home'
    },
    {
      id: 2,
      title: 'Support Ticket',
      description: 'Get help from our support team',
      icon: '🛠️',
      url: 'https://support.hellobar.com/support/tickets/new'
    },
    {
      id: 3,
      title: 'Blog',
      description: 'Tips and strategies to boost conversions',
      icon: '📝',
      url: 'https://www.hellobar.com/blog/'
    }
  ]
};

export default videoGuidesData; 